import cx from 'classnames'

import {
  alignmentStyles,
  styles,
  typeStyles,
  variantStyles,
} from './table-cell.styles'
import type { TableCellProps } from './table-cell.types'

export function TableCell(props: TableCellProps) {
  const {
    as = 'td',
    align = 'left',
    variant = 'page',
    className = '',
    children,
    ...htmlProps
  } = props

  const Component = as

  return (
    <Component
      className={cx(
        styles.base,
        alignmentStyles[align],
        typeStyles['text'],
        variantStyles[variant],
        className,
      )}
      {...htmlProps}
    >
      {children}
    </Component>
  )
}
